import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { InvoiceStatistic, DashboardCard, InvoiceStatisticSubset } from '../../../types';
import { subYears, format } from 'date-fns';
import { AuthService, GungUser as User } from 'gung-standard';
import { Observable, of, Subject } from 'rxjs';
import { InvoiceStatisticsService } from '../../../services/invoice-statistics.service';
import { DashboardKpiService } from '../../../services/dashboard-kpi.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'lib-monthly-sales-amount-summary-card',
    templateUrl: './monthly-sales-amount-summary-card.component.html',
    styleUrls: ['./monthly-sales-amount-summary-card.component.scss'],
    standalone: false
})
export class MonthlySalesAmountSummaryCardComponent implements OnInit, OnDestroy {
  protected unsubscribe: Subject<void> = new Subject();

  @Input()
  invoices: InvoiceStatisticSubset[];

  user: any;
  salesAmountThisMonth = 0;
  salesAmountLastYearThisMonth = 0;
  monthString = format(new Date(), 'MMMM yyyy');
  monthStringLastYear = format(subYears(new Date(), 1), 'MMMM yyyy');
  loaded = false;

  constructor(protected dashboardKpiService: DashboardKpiService) {}

  ngOnInit() {
    this.dashboardKpiService
      .getCurrentMonthSalesAmountComparison()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        this.salesAmountThisMonth = res.thisYear;
        this.salesAmountLastYearThisMonth = res.lastYear;
        this.loaded = true;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
